(function () {
  function initBeforeAfter(root) {
    var avatarsWrap = root.querySelector('[id^="FmBaAvatars-"]');
    var stage = root.querySelector('[id^="FmBaStage-"]');
    if (!avatarsWrap || !stage) return;

    var avatars = avatarsWrap.querySelectorAll('.fm-ba__avatar');
    var pairs = stage.querySelectorAll('.fm-ba__pair');

    avatarsWrap.addEventListener('click', function (event) {
      var btn = event.target.closest('.fm-ba__avatar');
      if (!btn || !avatarsWrap.contains(btn)) return;

      var target = btn.getAttribute('data-fm-ba-target');

      avatars.forEach(function (a) {
        var isActive = a === btn;
        a.classList.toggle('is-active', isActive);
        a.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      pairs.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-fm-ba-pair') === target);
      });
    });
  }

  document.querySelectorAll('.fm-ba').forEach(initBeforeAfter);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.fm-ba');
    if (section) initBeforeAfter(section);
  });
})();
